<template>
  <div class="carousel">
    <div class="container">
      <div class="carousel__wrapper">
        <h2 class="carousel__title">{{ t('home.cards.title') }}</h2>
        <swiper
          class="carousel__swiper"
          :modules="[Autoplay, Navigation]"
          :autoplay="{
            delay: 10000,
            disableOnInteraction: false,
          }"
          :breakpoints="{
            300: {
                slidesPerView: 1
            },
            1150: {
                slidesPerView: 2
            },
            1550: {
                slidesPerView: 3
            }
          }"
          :navigation="true"
          :loop="true"
          :speed="1500"
        >
          <swiper-slide>
            <img src="@images/steam.png" alt="steam" loading="lazy">
          </swiper-slide>
          <swiper-slide>
            <img src="@images/spotify.png" alt="spotify" loading="lazy">
          </swiper-slide>
          <swiper-slide>
            <img src="@images/googlePlay.png" alt="google play" loading="lazy">
          </swiper-slide>
          <swiper-slide>
            <img src="@images/steam.png" alt="steam" loading="lazy">
          </swiper-slide>
          <swiper-slide>
            <img src="@images/spotify.png" alt="spotify" loading="lazy">
          </swiper-slide>
          <swiper-slide>
            <img src="@images/googlePlay.png" alt="google play" loading="lazy">
          </swiper-slide>
        </swiper>
        <div class="carousel__line"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/navigation';
import 'swiper/css';
import {Autoplay, Navigation} from "swiper/modules";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.carousel {
  background-color: $main;
  background-image: url("@images/bg/curouselBg.png");
  background-position: center;
  background-size: cover;
  padding-block: 50px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }

  &__title {
    font-family: Poppins, sans-serif;
    font-size: 64px;
    font-weight: 700;
    color: $white;
    text-align: center;
  }

  &__swiper {
    width: 100%;

    & img {
      margin-inline: auto;
    }
  }

  &__line {
    margin-top: 20px;
    width: 100%;
    height: 1px;
    background-color: $white;
  }
}

:deep(.swiper-slide) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-button-prev) {
  color: $white;
  background-color: #6E9B86;
  padding: 20px 10px;
  border-radius: 15px;
  width: unset;
  height: unset;
}
:deep(.swiper-button-next) {
  color: $white;
  background-color: #6E9B86;
  padding: 20px 10px;
  border-radius: 15px;
  width: unset;
  height: unset;
}
:deep(.swiper-button-next::after) {
  font-size: 34px;
}
:deep(.swiper-button-prev::after) {
  font-size: 34px;
}

@media (max-width: 500px) {
  .carousel {
    &__title {
      font-size: 52px;
    }

    &__swiper {
      & img {
        width: 100%;
      }
    }
  }
}
</style>